import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/salesProof';
function initials(name: string) {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0]?.toUpperCase()).join('');
}
export function TestimonialCard({
  t,
  showProduct = false
}: {
  t: Testimonial;
  showProduct?: boolean;
}) {
  const stars = Math.max(0, Math.min(5, Math.round(t.rating)));
  return <figure className="flex h-full flex-col rounded-3xl border border-teal-soft bg-white p-5 shadow-soft sm:p-6" data-id="element-427" data-mp="2u8vt9glfuh4c">
      <div className="flex items-center gap-3" data-id="element-428" data-mp="2z7p93fo76k7o">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-teal-light font-heading text-sm font-black text-teal-dark" data-id="element-429" data-mp="3460ixqehsupw">
          {initials(t.name)}
        </span>
        <div className="min-w-0" data-id="element-430" data-mp="19rzix277i1o8">
          <p className="truncate font-heading text-base font-extrabold text-navy" data-id="element-431" data-mp="19t0wbdbp3094">{t.name}</p>
          <p className="flex items-center gap-1 truncate text-sm text-navy-soft" data-id="element-432" data-mp="1dst77wok9ihn">
            <MapPinIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0 text-teal" data-id="element-433" data-mp="htmbdmz6tizj" />
            {t.city}
            {showProduct && ' · 30 Días de Viandas Resueltas'}
          </p>
        </div>
      </div>
      <div className="mt-4 flex gap-0.5" role="img" aria-label={`${stars} de 5 estrellas`} data-id="element-434" data-mp="83je3al19ive">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} aria-hidden="true" className={i < stars ? 'h-4 w-4 fill-sun text-sun' : 'h-4 w-4 text-teal-soft'} data-id="element-435" data-mp="10rf4jxk0eejq" data-mpi={i} />)}
      </div>
      {t.image ? <img src={t.image} alt={`Mensaje de ${t.name}`} loading="lazy" decoding="async" className="mt-4 w-full rounded-2xl border border-teal-soft" data-id="element-436" data-mp="vqj0njznqseb" /> : <blockquote className="mt-3 text-base italic leading-relaxed text-navy" data-id="element-437" data-mp="3bjqbx0grolw9">“{t.quote}”</blockquote>}
    </figure>;
}